import { createContext, useContext, useState, useEffect } from 'react';
import { getSystemStats } from '../services/api';

const StatsContext = createContext();

export function StatsProvider({ children }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      const statsData = await getSystemStats();
      if (statsData) {
        setStats(statsData);
      }
    };
    fetchStats();
  }, []);

  return (
    <StatsContext.Provider value={stats}>
      {children}
    </StatsContext.Provider>
  );
}

export const useStats = () => useContext(StatsContext); 